import environment from '@environment';
import { SitePlatform } from 'core/enums/site-platform';

export const CountryCode = [
  // { alpha2: "DZ", alpha3: "DZA" },
  { alpha2: "AO", alpha3: "AGO", full: "Angola" },
  { alpha2: "BJ", alpha3: "BEN", full: "Benin" },
  { alpha2: "BW", alpha3: "BWA", full: "Botswana" },
  { alpha2: "BF", alpha3: "BFA", full: "Burkina Faso" },
  { alpha2: "BI", alpha3: "BDI", full: "Burundi" },
  { alpha2: "CM", alpha3: "CMR", full: "Cameroon" },
  { alpha2: "CV", alpha3: "CPV", full: "Cape Verde" },
  { alpha2: "CF", alpha3: "CAF", full: "Central African Republic" },
  { alpha2: "TD", alpha3: "TCD", full: "Chad" },
  { alpha2: "KM", alpha3: "COM", full: "Comoros" },
  { alpha2: "CG", alpha3: "COG", full: "Republic of the Congo" },
  { alpha2: "CD", alpha3: "COD", full: "DRC" },
  { alpha2: "CI", alpha3: "CIV", full: "Ivory Coast" },
  { alpha2: "DJ", alpha3: "DJI", full: "Djibouti" },
  // { alpha2: "EG", alpha3: "EGY" },
  { alpha2: "GQ", alpha3: "GNQ", full: "Equatorial Guinea" },
  { alpha2: "ER", alpha3: "ERI", full: "Eritrea" },
  { alpha2: "ET", alpha3: "ETH", full: "Ethiopia" },
  { alpha2: "GA", alpha3: "GAB", full: "Gabon" },
  { alpha2: "GM", alpha3: "GMB", full: "Gambia" },
  { alpha2: "GH", alpha3: "GHA", full: "Ghana" },
  { alpha2: "GN", alpha3: "GIN", full: "Guinea" },
  { alpha2: "GW", alpha3: "GNB", full: "Guinea-Bissau" },
  { alpha2: "KE", alpha3: "KEN", full: "Kenya" },
  { alpha2: "LS", alpha3: "LSO", full: "Lesotho" },
  { alpha2: "LR", alpha3: "LBR", full: "Liberia" },
  // { alpha2: "LY", alpha3: "LBY" },
  { alpha2: "MG", alpha3: "MDG", full: "Madagascar" },
  { alpha2: "ML", alpha3: "MLI", full: "Mali" },
  { alpha2: "MW", alpha3: "MWI", full: "Malawi" },
  { alpha2: "MR", alpha3: "MRT", full: "Mauritania" },
  { alpha2: "MU", alpha3: "MUS", full: "Mauritius" },
  // { alpha2: "YT", alpha3: "MYT" },
  // { alpha2: "MA", alpha3: "MAR" },
  { alpha2: "MZ", alpha3: "MOZ", full: "Mozambique" },
  { alpha2: "NA", alpha3: "NAM", full: "Namibia" },
  { alpha2: "NE", alpha3: "NER", full: "Niger" },
  { alpha2: "NG", alpha3: "NGA", full: "Nigeria" },
  // { alpha2: "RE", alpha3: "REU" },
  { alpha2: "RW", alpha3: "RWA", full: "Rwanda" },
  { alpha2: "ST", alpha3: "STP", full: "Sao Tome and principe" },
  { alpha2: "SN", alpha3: "SEN", full: "Senegal" },
  { alpha2: "SC", alpha3: "SYC", full: "Seychelles" },
  { alpha2: "SL", alpha3: "SLE", full: "Sierra Leone" },
  { alpha2: "SO", alpha3: "SOM", full: "Somalia" },
  { alpha2: "ZA", alpha3: "ZAF", full: "South Africa" },
  { alpha2: "SS", alpha3: "SSD", full: "South Sudan" },
  { alpha2: "SD", alpha3: "SDN", full: "Sudan" },
  { alpha2: "SZ", alpha3: "SWZ", full: "Eswatini" },
  { alpha2: "TZ", alpha3: "TZA", full: "Tanzania" },
  { alpha2: "TG", alpha3: "TGO", full: "Togo" },
  // { alpha2: "TN", alpha3: "TUN" },
  { alpha2: "UG", alpha3: "UGA", full: "Uganda" },
  // { alpha2: "EH", alpha3: "ESH" },
  { alpha2: "ZM", alpha3: "ZMB", full: "Zambia" },
  { alpha2: "ZW", alpha3: "ZWE", full: "Zimbabwe" },
];

export const GetCountryCodes = (platform?: SitePlatform) => {
  if (platform === SitePlatform.gotv) {
    const inclusionList = environment.GOTV_COUNTRY_CODE_INCLUSION_LIST;

    return CountryCode.filter(country => inclusionList.includes(country.alpha2.toLocaleLowerCase()))
  }

  return CountryCode;
}